import { render, staticRenderFns } from "./lorepointinfoadd.vue?vue&type=template&id=1ad0a865&scoped=true"
import script from "./lorepointinfoadd.vue?vue&type=script&lang=js"
export * from "./lorepointinfoadd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ad0a865",
  null
  
)

export default component.exports